import React from 'react'
import Select from 'react-select';
import './select.scss';
const SelectCustom = (props) => {
    
    const defaultOptions = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ];
    
    const Mainoptions = Array.isArray(props.options) ? props.options : defaultOptions;
    const customStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: '#003da5',
            border: 'none',
            borderBottom: '2px solid white',
            boxShadow: 'none',
            borderRadius: '0',
            '&:hover': {
                borderBottom: '2px solid white',
            },
        }),
        placeholder: (base) => ({
            ...base,
            color: 'white',
            fontSize: '20px',
        }),
        singleValue: (base) => ({
            ...base,
            color: 'white',
            fontSize: '20px',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: 'white',
            '&:hover': { color: '#ddd' },
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: 'white',
            border: '1px solid #ddd',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isFocused ? '#003da5' : '#003da5',
            backgroundColor: state.isFocused ? '#f0f8ff' : 'white',
        }),
    };
    return (
        <Select
            options={Mainoptions}
            placeholder="Select an industry"
            styles={customStyles}
            className="custom-react-select"
            classNamePrefix="react-select"
        />
    )
}

export default SelectCustom